//TODO: DONE! Export the Footer
import React from 'react';

const Footer = () => {
	return (
		<footer
			className='bg-dark text-center text-white p-1 fixed-bottom'
			style={{ letterSpacing: '0.1rem', textTransform: 'uppercase' }}
		>
			A simple Contact App
		</footer>
	);
};

export default Footer;
